"use client";

import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-2 w-full overflow-hidden rounded-full bg-backgroundAccent",
      className,
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={`size-full flex-1 transition-all ${(value || 0) > 100 ? "bg-red-500" : "bg-brand-primary"}`}
      style={{ transform: `translateX(-${100 - Math.min(value || 0, 100)}%)` }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
